 <template>
  <vs-table :data="quantidade">
    <template slot="thead">
      <vs-th>Email</vs-th>
      <vs-th>Name</vs-th>
    
    </template>
    <template>
      <vs-tr :key="numeroCampos" v-for="(tr, numeroCampos) in quantidade">
        <vs-td >{{ quantidade[numeroCampos] }}</vs-td>
        <vs-td ><input v-model="amount[quantidade]"></input></vs-td>
      </vs-tr>
    </template>
     <button @click="teste">Oi</button>
  </vs-table>
  
</template> 
<script>
export default {
  data() {
    return {
      numeroCampos : 2,
      quantidade: [1,2,3],
      amount: []
    }
  },
  methods:{
    teste(){
      
    }
  },
  created(){
      this.$set(this, "fieldValue", vue.contact.contactInfo[this.fieldname]);
  }
};
</script> 
